module.exports = __webpack_public_path__ + "static/media/11.3aa7908d.jpeg";